module.exports = __webpack_public_path__ + "img/storage-location.230e8855.svg";